import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type addColumnToMatrixElementButton_AddColumnToMatrixElementMutation } from "@relay/addColumnToMatrixElementButton_AddColumnToMatrixElementMutation.graphql";
import { ADD_COLUMN_TO_MATRIX_ELEMENT_MUTATION } from "./add-column-to-matrix-element-button.graphql";
import { type AddColumnToMatrixElementButtonProps } from "./add-column-to-matrix-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const AddColumnToMatrixElementButton = ({
	matrixElementId,
}: AddColumnToMatrixElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();

	const [addColumnToMatrixElement] =
		useMutation<addColumnToMatrixElementButton_AddColumnToMatrixElementMutation>(
			ADD_COLUMN_TO_MATRIX_ELEMENT_MUTATION,
		);

	return (
		<Button
			type="button"
			className="m-2 flex flex-grow-1"
			label={t("educationalOffer.newColumn")}
			onClick={() => {
				addColumnToMatrixElement({
					variables: {
						input: {
							matrixElementId,
							columnTitle: t("educationalOffer.newColumn"),
							correctAnswerContent: t("educationalOffer.correctAnswer"),
						},
					},
					updater: setDraft,
				});
			}}
		/>
	);
};
